<p-dialog
  [header]="'Duplicate Vehicle Registration'"
  [responsive]="true"
  [modal]="true"
  (onHide)="cancel()"
  [(visible)]="showDuplicateTaskDialog"
  [style]="{ width: '700px' }"
>
  <div>
    Vehicle registration
    <strong style="text-transform: uppercase">{{ registrationNumber }}</strong> is currently in use.
    If this is a duplicated booking you may be charged in full if another driver is assigned. Are
    you certain you wish to continue to the next step ?
  </div>

  <div class="mt-2">The following movements are already associated with the same registration:</div>

  <div class="mt-2" style="max-height: 200px; overflow-y: auto">
    <table class="w-100 outer-table">
      <thead>
        <tr>
          <th>Order #</th>
          <th>Location</th>
          <th>Scheduled Dates</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let task of tasks" class="task-row">
          <td>
            {{ task.order?.job.jobNumber }}
          </td>
          <td>
            <table>
              <tr>
                <td style="padding-right: 5px; vertical-align: middle">
                  <img src="assets/images/svg/point-to-point-vertical.svg" />
                </td>
                <td>
                  <div class="location-line mb-1">
                    {{ task.pickupLocation?.businessName || task.pickupLocation?.city }},
                    {{ task.pickupLocation?.postcode }}
                  </div>
                  <div class="location-line">
                    {{ task.dropoffLocation?.businessName || task.dropoffLocation?.city }},
                    {{ task.dropoffLocation?.postcode }}
                  </div>
                </td>
              </tr>
            </table>
          </td>
          <td>
            {{ task.pickupEarliestDateTime | datex : 'ddd MMM DD' }} -
            {{ task.dropoffLatestDateTime | datex : 'ddd MMM DD' }}
          </td>
          <td>
            <span
              class="link-style cursor-pointer"
              (click)="gotoJobScreen(task.order.job.id, task.order.id)"
              >View Order</span
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <p-footer>
    <div class="text-right">
      <p-button label="No, Cancel" class="ui-button-tertiary" (click)="cancel()"></p-button>
      <p-button label="Yes, Next" class="ui-button-primary" (click)="continue()"></p-button>
    </div>
  </p-footer>
</p-dialog>
